import { useEffect, useRef, useState } from 'react';
import { Subject } from 'rxjs';
import { concatMap } from 'rxjs/operators';

function useEditorUpdater(getUpdateKey, onContent) {

  const [reloadKey, setReloadKey] = useState(0);
  const currentUpdateKeyReference = useRef(getUpdateKey());
  const updateSubject = useRef(new Subject());
  const isInitialRender = useRef(true);
  const subscriptionReference = useRef(null);

  async function handleNewContent(content) {

    try {

      const result = await onContent(content, currentUpdateKeyReference.current);

      if (result.updated === true) {
        currentUpdateKeyReference.current = result.nextUpdateKey;
      } else {
        subscriptionReference.current.unsubscribe();
        setReloadKey((prevKey) => prevKey + 1);
      }

    } catch (exception) {

      // eslint-disable-next-line no-console
      console.error(exception);

    }

  }

  useEffect(() => {
    if (subscriptionReference.current) {
      subscriptionReference.current.unsubscribe();
    }

    // Create a new subject for each subscription reset
    updateSubject.current = new Subject();

    subscriptionReference.current = updateSubject.current.pipe(
      concatMap(handleNewContent)
    ).subscribe();

    return () => {
      subscriptionReference.current.unsubscribe();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadKey]);

  function handleContentChange(content) {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    updateSubject.current.next(content);
  }

  useEffect(() => {
    currentUpdateKeyReference.current = getUpdateKey();
  }, [getUpdateKey]);

  function setUpdateKey(updateKey) {
    currentUpdateKeyReference.current = updateKey;
  }

  return { handleContentChange, updateSubject, setUpdateKey };
}

export default useEditorUpdater;